<template>
    <div v-if="isReady" class="background-inbox-card" v-resize="onResize">
        <v-row no-gutters class="standard-row font-for-header-tabs d-flex justify-space-between" align="center" style="font-weight: 700; padding: 21px 4.4% 0% 2.5%;">
            <v-col cols="11" sm="11" md="auto" lg="auto">
                <v-slide-group show-arrows mandatory v-model="permissionTabs" color="black">
                    <v-slide-item v-slot="{ active, toggle }" :value="permission" v-for="(permission, indexPermission) in myPermission" :key="`permission_${indexPermission}${permission}`">
                        <v-btn :input-value="active" active-class="select-header-tabs" class="font-for-header-tabs" @click="toggle" height="52" depressed rounded text>
                            {{ permission.inbox.toUpperCase() }}
                        </v-btn>
                    </v-slide-item>
                </v-slide-group>
            </v-col>
            <v-col cols="1" sm="1" v-if="windowSize.x < 960" class="d-flex justify-end">
                <template>
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" color="#414040">
                                <v-icon size="30">mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list style="background-color: #414040;">
                            <v-list-item dense @click="goToDownloadReport()">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme white--text" style="font-size: 16px; line-height: 25px;">Dowload Report</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list> 
                    </v-menu>
                </template>
            </v-col>
            <v-col v-else md="auto" lg="">
                <span class="d-flex mt-5 mt-sm-0" :class="windowSize.x <= 600? 'justify-center': 'justify-end'">
                    <v-btn rounded color="#0B68D6" class="white--text text-center download-report-inbox-btn" @click="goToDownloadReport()" height="53" width="193" style="font-weight: 700; font-size: 15px;">
                        Download Report
                    </v-btn>
                </span>
            </v-col>
        </v-row>
        <v-row no-gutters class="standard-row font-theme" align="center" style="font-weight: 700; padding: 20px 4.4% 0% 4.4%;">
            <v-row no-gutters class="standard-row font-theme" align="center">
                <v-col cols="auto" sm="auto" md="auto" lg="auto" style="font-size: 15px;" class="ml-4 ml-sm-0">
                    ค้นหา
                </v-col>
                <v-col cols="" sm="" md="4" lg="4" class="ml-sm-8">
                    <v-text-field dense outlined hide-details color="black" background-color="white" height="42" class="font-theme custom-search-text-field" v-model="holdKeyword" @input="!holdKeyword? checkRowsAndPageBeforeSearch(holdKeyword): ''" @keyup.enter="checkRowsAndPageBeforeSearch(holdKeyword)">
                        <template v-slot:append v-if="windowSize.x < 600">
                            <v-btn icon style="margin-top: 3px" @click="checkRowsAndPageBeforeSearch(holdKeyword)">
                                <v-icon size="38">mdi-magnify</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col v-if="windowSize.x > 600" sm="auto" md="auto" lg="auto" class="ml-5">
                    <v-btn rounded color="#0B68D6" class="white--text" height="42" width="125" style="font-weight: 700; font-size: 15px; box-shadow: none;" @click="checkRowsAndPageBeforeSearch(holdKeyword)">
                        Search
                    </v-btn>
                </v-col>
            </v-row>
            <v-row no-gutters class="standard-row font-theme pt-4 pt-sm-7" align="center">
                <v-col cols="12" sm="3" md="2" lg="1" style="font-size: 15px;" class="ml-4 ml-sm-0">
                    ประเภทเอกสาร
                </v-col>
                <v-col cols="12" sm="9" md="4" lg="4" class="ml-lg-0">
                    <v-autocomplete :items="documentType" v-model="selectedDoctype" hide-details outlined dense height="42" item-text="name" append-icon="mdi-chevron-down" background-color="white" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" class="custom-search-dropdown" return-object @change="checkPageForGetTransaction()">
                        <template v-slot:item="data">
                            <v-list-item-content>
                                <v-list-item-title class="font-theme" style="font-size: 15px; font-weight: 700; line-height: 30px;">{{ data.item.name }}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <template v-slot:no-data>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme" style="font-size: 15px; font-weight: 700; line-height: 30px;">ไม่พบข้อมูล</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-spacer v-if="windowSize.x >= 960 && windowSize.x < 1264"></v-spacer>
                <v-col cols="12" sm="3" md="1" lg="1" style="font-size: 15px;" class="ml-4 ml-sm-0 ml-lg-16 mt-4 mt-sm-7 mt-md-0 pl-lg-10">
                    ช่วงเวลา
                </v-col>
                <v-col cols="12" sm="9" md="4" lg="4" class="ml-lg-0 mt-0 mt-sm-7 mt-md-0">
                    <v-menu offset-y v-model="dateMenu" min-width="auto" :close-on-content-click="false" transition="scale-transition">
                        <template v-slot:activator="{ on }">
                            <v-text-field dense hide-details clearable readonly v-on="on" color="black" outlined background-color="white" height="42" :value="dateRangeShow" @click:clear="dateRangeFilter = [], getTransaction()" class="font-theme custom-search-text-field clear-icon-date-picker"></v-text-field>
                        </template>
                        <v-date-picker color="#0B68D6" range no-title v-model="dateRangeFilter" show-current locale="th" @change="dateRangeFilter.length == 2? searchTransactionByDate() : ''" class="font-theme detail-date-picker-inbox" :max="new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row no-gutters class="standard-row font-theme pt-5 display-pc-only" align="center">
                <v-slide-group show-arrows mandatory v-model="documentStatus">
                    <v-slide-item v-slot="{ active, toggle }" value="">
                        <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab" @click="toggle" height="51" depressed rounded text>
                            <v-badge inline color="#3B639F" :content="countTransaction[''].toString()" style="font-weight: 700; font-size: 15px;" class="custom-badge-content">
                                เอกสารทั้งหมด
                            </v-badge>
                        </v-btn>
                    </v-slide-item>
                    <v-slide-item v-slot="{ active, toggle }" value="waiting">
                        <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab" @click="toggle" height="51" depressed rounded text>
                            <v-badge inline color="#7FE0DA  " :content="countTransaction['waiting'].toString()" style="font-weight: 700; font-size: 15px;" class="custom-badge-content">
                                รออนุมัติ
                            </v-badge>
                        </v-btn>
                    </v-slide-item>
                    <v-slide-item v-slot="{ active, toggle }" value="inprogress">
                        <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab" @click="toggle" height="51" depressed rounded text>
                            <v-badge inline color="#EEC120" :content="countTransaction['inprogress'].toString()" style="font-weight: 700; font-size: 15px;" class="custom-badge-content">
                                กำลังดำเนินการ
                            </v-badge>
                        </v-btn>
                    </v-slide-item>
                    <v-slide-item v-slot="{ active, toggle }" value="approved">
                        <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab" @click="toggle" height="51" depressed rounded text>
                            <v-badge inline color="#74CA5F" :content="countTransaction['approved'].toString()" style="font-weight: 700; font-size: 15px;" class="custom-badge-content">
                                อนุมัติ
                            </v-badge>
                        </v-btn>
                    </v-slide-item>
                    <v-slide-item v-slot="{ active, toggle }" value="rejected">
                        <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab" @click="toggle" height="51" depressed rounded text>
                            <v-badge inline color="#EC9589" :content="countTransaction['rejected'].toString()" style="font-weight: 700; font-size: 15px;" class="custom-badge-content">
                                ปฎิเสธ
                            </v-badge>
                        </v-btn>
                    </v-slide-item>
                    <v-slide-item v-slot="{ active, toggle }" value="cancel">
                        <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab" @click="toggle" height="51" depressed rounded text>
                            <v-badge inline color="#BDBDBD" :content="countTransaction['cancel'].toString()" style="font-weight: 700; font-size: 15px;" class="custom-badge-content general-badge-color">
                                ยกเลิก
                            </v-badge>
                        </v-btn>
                    </v-slide-item>
                </v-slide-group>
            </v-row>
            <v-row no-gutters class="standard-row pt-4 pt-sm-7 display-mobile-only" align="center">
                <v-col cols="12" style="font-size: 15px;" class="ml-4">
                    สถานะเอกสาร
                </v-col>
                <v-col cols="12">
                    <v-select :items="statusDocument" hide-details outlined dense height="42" item-text="status" item-value="value" v-model="documentStatus" append-icon="mdi-chevron-down" background-color="white" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" class="custom-search-dropdown">
                        <template v-slot:item="data">
                            <v-list-item-content>
                                <v-list-item-title class="font-theme" style="font-size: 15px; font-weight: 700; line-height: 30px;">{{ data.item.status }}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                    </v-select>
                </v-col>
            </v-row>
            <v-row no-gutters class="standard-row mt-4 mb-7">
                <v-data-table :headers="selectedBiz.tax_id === '0107544000094'? headersBizInet : headers" range :items="myTransactions" fixed-header class="elevation-0 list-data-table" style="width: 100%" :options.sync="optionsTransaction" @click:row="goToDocumentDetail($event._id)" :server-items-length="countTransaction[documentStatus]" :footer-props="{ 'items-per-page-options': [20, 30, 40, 50], 'items-per-page-text':'จำนวนแถวต่อหน้า' }" mobile-breakpoint="601">
                    <template v-slot:[`item.document_status`] = "{ item }">
                        <span v-if="Boolean(item.document_status_po) === true" style="color: #DA8EF2;">PO Cancel</span>
                        <span v-else-if="item.document_status.toLowerCase() === 'w'" style="color: #EEC120;">On Progress</span>
                        <span v-else-if="item.document_status.toLowerCase() === 'y'" style="color: #1BDE3A;">Success</span>
                        <span v-else-if="item.document_status.toLowerCase() === 'r'" style="color: #E08D8D;">Rejected</span>
                        <span v-else-if="item.document_status.toLowerCase() === 'c'" style="color: #BDBDBD;">Cancel</span>
                    </template>
                    <template v-slot:[`item.document_status_dwf`] = "{ item }">
                        <span v-if="Boolean(item.document_status_po) === true" style="color: #DA8EF2;">PO Cancel</span>
                        <span v-else-if="item.document_status_dwf.toLowerCase() === 'w'" style="color: #EEC120;">On Progress</span>
                        <span v-else-if="item.document_status_dwf.toLowerCase() === 'y'" style="color: #1BDE3A;">Success</span>
                        <span v-else-if="item.document_status_dwf.toLowerCase() === 'r'" style="color: #E08D8D;">Rejected</span>
                        <span v-else-if="item.document_status_dwf.toLowerCase() === 'c'" style="color: #BDBDBD;">Cancel</span>
                    </template>
                    <template v-slot:[`item.budget_status`] = "{ item }">
                        <span v-if="item.budget_status === 'onprogress' || item.budget_status === 'waiting'" style="color: #EEC120;">On Progress</span>
                        <span v-else-if="item.budget_status === 'success'" style="color: #1BDE3A;">Success</span>
                        <span v-else-if="item.budget_status === 'reject'" style="color: #E08D8D;">Rejected</span>
                        <span v-else-if="item.budget_status === 'cancel'" style="color: #BDBDBD;">Cancel</span>
                    </template>
                    <template v-slot:[`item.account_status`] = "{ item }">
                        <span v-if="item.account_status === 'waiting'" style="color: #EEC120;">On Progress</span>
                        <span v-else-if="item.account_status === 'success'" style="color: #1BDE3A;">Success</span>
                        <span v-else-if="item.account_status === 'reject'" style="color: #E08D8D;">Rejected</span>
                        <span v-else-if="item.account_status === 'cancel'" style="color: #BDBDBD;">Cancel</span>
                    </template>
                    <!-- <template v-slot:[`item.send_dwf`] = "{ item }">
                        <v-icon v-if="item.send_dwf" size="30" color="#1BDE3A">mdi-check-circle-outline</v-icon>
                        <v-icon v-else-if="!item.send_dwf && item.document_status.toLowerCase() !== 'w'" size="30" :color="colorIconFailDwf(item.document_status.toLowerCase())">mdi-close-circle-outline</v-icon>
                    </template> -->
                    <template v-slot:[`item.copy_doc`] = "{ item }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" @click.stop="confirmCopyFlow(item._id)">
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7319 13.0537V3.6786C15.7319 2.19925 14.5327 1 13.0533 1H3.67823C2.19888 1 0.999625 2.19925 0.999625 3.6786V13.0537C0.999625 14.5331 2.19888 15.7323 3.67823 15.7323H13.0533C14.5327 15.7323 15.7319 14.5331 15.7319 13.0537Z" stroke="#2A2E3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M6.35754 15.7323V18.4109C6.35754 19.8903 7.55679 21.0895 9.03614 21.0895H18.4112C19.8906 21.0895 21.0898 19.8903 21.0898 18.4109V9.0358C21.0898 7.55645 19.8906 6.3572 18.4112 6.3572H15.7326" stroke="#2A2E3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </v-btn>
                            </template>
                            <span class="font-theme">คัดลอกเอกสาร</span>
                        </v-tooltip>
                    </template>
                    <template slot="no-data">
                        <v-alert class="text-center d-flex justify-center">
                            ไม่พบข้อมูล
                        </v-alert>
                    </template>
                    <template v-slot:no-results>
                        <v-alert class="text-center d-flex justify-center">
                            ไม่พบข้อมูล
                        </v-alert>
                    </template>
                    <template v-slot:footer.page-text="items">
                        {{ items.pageStart }} - {{ items.pageStop }} จาก {{ items.itemsLength }} แถว
                    </template>
                </v-data-table>
            </v-row>
        </v-row>
        <ConfirmCopyDocument />
        <DownloadReportModal />
    </div>
</template>

<script>
import { MainFunction } from '@/functions/mainFunction.js'
import { EventBus } from '../EventBus'
import ConfirmCopyDocument from '../components/ConfirmCopyDocument.vue'
import DownloadReportModal from '../components/DownloadReportModal.vue'
    export default {
        components: {
            ConfirmCopyDocument,
            DownloadReportModal
        },
        data: () => ({
            selectedDoctype: {
                "name": "ทั้งหมด",
                "pr_id": "00",
                "_id": ""
            },
            statusDocument: [
                { status: 'เอกสารทั้งหมด', value: ''},
                { status: 'รออนุมัติ', value: 'waiting'},
                { status: 'กำลังดำเนินการ', value: 'inprogress'},
                { status: 'อนุมัติ', value: 'approved'},
                { status: 'ปฎิเสธ', value: 'rejected'},
                { status: 'ยกเลิก', value: 'cancel'}
            ],
            headers: [
                { text: "เลขที่เอกสาร"     , value: "document_id"        , align: "center", sortable: false, width: '100px' },
                { text: "PO"             , value: "po_number"          , align: "center", sortable: false, width: '100px' },
                { text: "ผู้ส่ง"            , value: "sender"             , align: "center", sortable: false, width: '160px' },
                { text: "รูปแบบ Work Flow", value: "flow_name"          , align: "center", sortable: false, width: '200px' },
                { text: "รายละเอียด"       , value: "description"        , align: "center", sortable: false, width: '150px' },
                { text: "วันที่"            , value: "updated_at"          , align: "center", sortable: false, width: '10%' },
                { text: "Portal"         , value: "document_status"     , align: "center", sortable: false, width: '10%' },
                { text: "DWF"            , value: "document_status_dwf" , align: "center", sortable: false, width: '4%' },
                { text: ""               , value: "copy_doc"            , align: "center", sortable: false, width: '4%' }
            ],
            headersBizInet: [
                { text: "เลขที่เอกสาร"     , value: "document_id"        , align: "center", sortable: false, width: '100px' },
                { text: "PO"             , value: "po_number"          , align: "center", sortable: false, width: '100px' },
                { text: "ผู้ส่ง"            , value: "sender"             , align: "center", sortable: false, width: '160px' },
                { text: "รูปแบบ Work Flow", value: "flow_name"          , align: "center", sortable: false, width: '200px' },
                { text: "รายละเอียด"       , value: "description"        , align: "center", sortable: false, width: '150px' },
                { text: "วันที่"            , value: "updated_at"          , align: "center", sortable: false, width: '10%' },
                { text: "บันทึกงบ"            , value: "budget_status"    , align: "center", sortable: false, width: '10%' },
                { text: "บัญชี"            , value: "account_status"      , align: "center", sortable: false, width: '10%' },
                // { text: "Portal"         , value: "document_status"     , align: "center", sortable: false, width: '10%' },
                { text: "DWF"            , value: "document_status_dwf" , align: "center", sortable: false, width: '4%' },
                { text: ""               , value: "copy_doc"            , align: "center", sortable: false, width: '4%' }
            ],
            myPermission: [{
                inbox   : 'INBOX',
                dept_id : ''
            }],
            permissionTabs: {
                inbox   : 'INBOX',
                dept_id : ''
            },
            optionsTransaction: { 
                page: 1,
                itemsPerPage: 20
            },
            windowSize: { x: 0, y: 0 },
            trigRowPerPage: false,
            countTransaction: {},
            dateRangeFilter: [],
            myTransactions: [],
            isChangeTab: false,
            documentStatus: '',
            callApiPending: 0,
            documentType: [],
            holdKeyword: '',
            dateMenu: false,
            isReady: false,
            keyword: '',
        }),
        watch: {
            "optionsTransaction.page"(newValue) {
                if (newValue != 1 || !this.isChangeTab) {
                    this.getTransaction()
                    this.trigRowPerPage = true
                }
            },
            "optionsTransaction.itemsPerPage"() {
                if (!this.trigRowPerPage) {
                    this.optionsTransaction.page = 1
                    this.getTransaction()
                }
            },
            "documentStatus"() {
                this.optionsTransaction.page = 1
                this.getTransaction()
                this.isChangeTab = true
            },
            "permissionTabs"() {
                this.checkPageForGetTransaction()
            },
            "callApiPending"(val) {
                if (val > 0) {
                    EventBus.$emit('loadingState', true)
                } else {
                    EventBus.$emit('loadingState', false)
                }
            }
        },
        computed: {
            dateRangeShow() {
                let formatDate = ''
                if (this.dateRangeFilter.length === 2) {
                    formatDate = this.dateRangeFilter.map(element => MainFunction.shortDate(element)).join('  —  ')
                } else {
                    formatDate = ''
                }
                return formatDate
            },
            selectedBiz() {
                return this.$store.state.confirmSelectedBiz
            },
            raDetail() {
                return this.$store.state.raDetail
            },
            permissionInbox() {
                return this.$store.state.permissionInbox
            }
        },
        mounted () {
            const indexPermission = this.permissionInbox?.findIndex(e => e.inbox === "บัญชี") || null
            if (indexPermission >= 0) {
                const tempDataPermission = this.permissionInbox[indexPermission]
                this.permissionInbox.splice(indexPermission, 1)
                this.permissionInbox.push(tempDataPermission)
            }
            this.onResize()
            this.getTransaction()
            this.getDoctypeList()
            this.$store.commit('setSelectedPermissionInbox', null)
        },
        methods: {
            onResize() {
                this.windowSize = { x: window.innerWidth }
            },
            checkRowsAndPageBeforeSearch(params) {
                if (this.keyword === params) {
                    return
                }
                this.keyword = params.trim()
                this.checkPageForGetTransaction()
            },
            async getTransaction() {
                try {
                    this.callApiPending++
                    const countTransactions = {
                        baseURL : this.$api_url,
                        url     : `/transaction/api/v1/count_document?tax_id=${this.selectedBiz.tax_id}&start_date=${this.dateRangeFilter.sort()[0] || ''}&end_date=${this.dateRangeFilter.sort()[1] || ''}&keyword=${this.keyword}&inbox=${this.permissionTabs?.inbox || ''}&document_type_id=${this.selectedDoctype._id || ''}&dept_id=${this.raDetail.orgchart?.department?.map(e => e.orgchartId).join('') || ''}`,
                        method  : 'GET'
                    }
                    const searchTransactions = {
                        baseURL : this.$api_url,
                        url     : `/transaction/api/v1/transaction_search?tax_id=${this.selectedBiz.tax_id}&document_status=${this.documentStatus || ''}&keyword=${this.keyword}&start_date=${this.dateRangeFilter.sort()[0] || ''}&end_date=${this.dateRangeFilter.sort()[1] || ''}&document_type_id=${this.selectedDoctype._id || ''}&offset=${(this.optionsTransaction.page - 1) * this.optionsTransaction.itemsPerPage || 0}&limit=${this.optionsTransaction.itemsPerPage}&inbox=${this.permissionTabs?.inbox || ''}&dept_id=${this.raDetail.orgchart?.department?.map(e => e.orgchartId).join('') || ''}`,
                        method  : 'GET'
                    }
                    const data = await Promise.all([ this.axios(countTransactions), this.axios(searchTransactions) ])
                    this.countTransaction = {
                        'approved' : data[0].data.result.approved  || 0,
                        'cancel' : data[0].data.result.cancel   || 0,
                        'inprogress' : data[0].data.result.inprogress  || 0,
                        'rejected' : data[0].data.result.rejected   || 0,
                        'waiting'  : data[0].data.result.waiting || 0,
                        ''  : data[0].data.result.total    || 0
                    }
                    this.myTransactions = []
                    if (data[1].data.data.length) {
                        for (let i = 0; i < data[1].data.data.length; i++) {
                            data[1].data.data[i].updated_at = MainFunction.shortDate(data[1].data.data[i].updated_at)
                            this.myTransactions.push(data[1].data.data[i])
                        }
                        $(".list-data-table.v-data-table > .v-data-table__wrapper").scrollTop(0)
                    }
                } catch (error) {
                    this.myTransactions   = []
                    this.countTransaction = {
                        'approved': 0,
                        'cancel': 0,
                        'inprogress': 0,
                        'rejected': 0,
                        'waiting': 0,
                        '' : 0
                    }
                    this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error')
                    console.log(error)
                } finally {
                    this.callApiPending--
                    this.isChangeTab = false
                    this.trigRowPerPage = false
                    if (!this.callApiPending) {
                        this.isReady = true
                    }
                }
            },
            async getDoctypeList() {
                try {
                    this.callApiPending++
                    const { data } = await this.axios.get(`${this.$api_url}/document_type/api/v1/get_document_type?tax_id=${this.selectedBiz.tax_id}`)
                    if (data.status && data.data.length) {
                        this.documentType = data.data
                        this.documentType.unshift({
                            name : "ทั้งหมด",
                            pr_id: "00",
                            _id  : ""
                        })
                    } else {
                        this.documentType = []
                    }
                } catch (error) {
                    console.log(error)
                    this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error')
                } finally {
                    this.myPermission = []
                    if (this.permissionInbox.length) {
                        for (let i = 0; i < this.permissionInbox.length; i++) {
                            if(this.permissionInbox[i].inbox.toLowerCase() === 'report') continue
                            this.myPermission.push({
                                inbox   : this.permissionInbox[i].inbox            || '',
                                dept_id : this.permissionInbox[i].dept_id.join('') || ''
                            })
                        }
                    }
                    this.callApiPending--
                    if (!this.callApiPending) {
                        this.isReady = true
                    }
                }
            },
            // async getDoctypeAndPermission() {
            //     try {
            //         const getDocType = {
            //             baseURL : this.$api_url,
            //             url     : `/document_type/api/v1/get_document_type?tax_id=${this.selectedBiz.tax_id}`,
            //             method  : 'GET'
            //         }
            //         const getPermission = {
            //             baseURL : this.$api_url,
            //             url     : `/permission/api/v1/inbox_permission?tax_id=${this.selectedBiz.tax_id}`,
            //             method  : 'GET'
            //         }
            //         this.callApiPending++
            //         const data = await Promise.allSettled([ this.axios(getDocType), this.axios(getPermission) ])
            //         if (data[0].status === 'fulfilled' && data[0].value.data.status && data[0].value.data.data.length) {
            //             this.documentType = data[0].value.data.data
            //             this.documentType.unshift({
            //                 name : "ทั้งหมด",
            //                 pr_id: "00",
            //                 _id  : ""
            //             })
            //         } else {
            //             this.documentType = []
            //         }
            //         if (data[1].status === 'fulfilled' && data[1].value.data.status && data[1].value.data.data.length) {
            //             this.myPermission = []
            //             for (let i = 0; i < data[1].value.data.data.length; i++) {
            //                 this.myPermission.push({
            //                     inbox   : data[1].value.data.data[i].inbox            || '',
            //                     dept_id : data[1].value.data.data[i].dept_id.join('') || ''
            //                 })
            //             }
            //         } else {
            //             this.myPermission = {}
            //         }
            //     } catch (error) {
            //         console.log(error);
            //     } finally {
            //         this.callApiPending--
            //         if (!this.callApiPending) {
            //             this.isReady = true
            //         }
            //     }
            // },
            goToDocumentDetail(id) {
                this.$store.commit('setTransactionId', id)
                this.$store.commit('setSelectedPermissionInbox', this.permissionTabs?.inbox || null)
                this.$router.push({ path: '/inbox/purchase_detail' })
            },
            colorIconFailDwf(status) {
                let colorIcon = ''
                switch (status) {
                    case 'c':
                        colorIcon = '#2A2E3B'
                        break;
                    case 'r':
                        colorIcon = '#E08D8D'
                        break;
                    case 'y':
                        colorIcon = '#1BDE3A'
                        break;
                    default:
                        colorIcon = 'black'
                        break;
                }
                return colorIcon
            },
            searchTransactionByDate() {
                this.dateMenu = false
                this.dateRangeFilter = this.dateRangeFilter.sort()
                this.checkPageForGetTransaction()
            },
            confirmCopyFlow(id) {
                EventBus.$emit('confirmCopyDoc', id)
            },
            goToDownloadReport(){
                const aboutReport = {
                    url        : '/report/api/v1/export_reportinbox',
                    permission : this.permissionTabs.inbox,
                    from       : 'inbox'
                }
                EventBus.$emit('openDownloadReportModal', aboutReport)
            },
            checkPageForGetTransaction() {
                if (this.optionsTransaction.page === 1) {
                    this.getTransaction()
                } else {
                    this.optionsTransaction.page = 1
                }
            },
            alert(title = '', text = 'Fail', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                });
            }
        }
    }
</script>

<style>
    .background-inbox-card {
        background: #FFFFFF !important;
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25) !important;
        border-radius: 23px;
        margin: 60px 2% 3.61% 2%;
    }

    .tab-detail {
        font-size: 36px;
        font-weight: 700;
        color: white !important;
    }

    .font-for-header-tabs {
        font-family: 'Sarabun', sans-serif;
        font-size: calc(100% + 0.56vw) !important;
        font-weight: 700;
        letter-spacing: 2px;
        color: #8D8D8D !important;
    }

    .font-for-header-tabs:before {
        background: transparent !important;
    }

    .document-status-tab:before {
        background: transparent !important;
    }

    .select-header-tabs {
        background: #73737380 !important;
        color: black !important;
    }

    .tab-detail-active {
        background: rgba(255, 254, 254, 0.5) !important;
        border-radius: 30px;
        opacity: 1;
        color: black !important;
    }

    .v-btn {
        text-transform: inherit;
    }

    .custom-search-text-field {
        border-radius: 30px !important;
    }

    .custom-search-dropdown {
        border-radius: 30px !important;
    }

    .custom-search-dropdown.v-text-field--outlined fieldset {
        border-color: black !important;
    }

    .custom-search-text-field.v-text-field--outlined fieldset {
        border-color: black !important;
    }

    .custom-search-dropdown .v-input__control .v-input__slot .v-select__slot .v-input__append-inner .v-input__icon {
        margin-top: 8px;
    }

    .custom-badge-content {
        letter-spacing: 0 !important;
    }

    .clear-icon-date-picker .v-input__control .v-input__slot .v-input__append-inner .v-input__icon--clear {
        margin-top: 8px;
    }

    .custom-badge-content .v-badge__wrapper span {
        height: 27px;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 8px;
        border-radius: 20px;
    }

    .custom-badge-content .v-badge__wrapper {
        margin-right: 0px;
        margin-left: 10px;
    }

    .selected-status-tab {
        background-color: #D9D9D9;
    }

    .list-data-table .v-data-table__wrapper table .v-data-table-header tr th {
        background-color: #F1F0F0;
        height: 56px;
        box-shadow: none;
    }

    .list-data-table.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover {
        cursor: pointer;
    }

    .list-data-table .v-data-table__wrapper table tbody tr td {
        font-size: 13px;
        border-bottom: none !important;
    }

    .list-data-table {
        border-radius: 10px;
        overflow-y: auto;
    }

    .list-data-table thead th:first-child {
        border-radius: 5px 0 0 0;
    }

    .list-data-table thead th:last-child {
        border-radius: 0 5px 0 0;
    }

    .list-data-table .v-data-table__wrapper table thead tr th {
        font-size: 15px;
    }

    .list-data-table.v-data-table > .v-data-table__wrapper {
        height: calc(100vh - 259px);
        overflow: auto;
        scroll-behavior: smooth;
    }

    .list-data-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent !important;
    }

    .list-data-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: transparent !important;
    }

    .list-data-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #F7F6F6;;
    }

    .list-data-table > .v-data-table__wrapper > table > thead > tr > th {
        color: black !important;
    }

    .detail-date-picker-inbox .theme--light.v-date-picker-table th {
        color: black !important;
        background-color: #E3E3E35E !important;
        font-size: 16px !important;
    }

    .detail-date-picker-inbox .v-picker__body .v-date-picker-table table {
        border-spacing: 0 !important;
    }

    .custom-search-dropdown.v-select.v-input--dense .v-select__selection--comma  {
        margin-left: 5px;
    }

    .custom-search-dropdown.v-text-field:not(.v-text-field--single-line) input {
        margin-left: 5px;
        line-height: 30px;
    }

    .custom-search-text-field .v-input__control .v-input__slot .v-text-field__slot input {
        margin-left: 5px;
        margin-right: 5px;
    }

    .custom-search-text-field .v-input__control .v-input__slot .v-text-field__slot input {
        line-height: 30px;
    }

    .custom-search-dropdown .v-input__control .v-input__slot .v-select__slot .v-select__selections {
        line-height: 30px;
    }

    .download-report-inbox-btn {
        border-radius: 30px;
        box-shadow: none;
    }

    @media only screen and (max-width: 600px) {

        .list-data-table .v-data-table__wrapper table tbody tr td:last-child {
            border-bottom: 3px solid rgba(0, 0, 0, 0.12) !important;
        }

        .list-data-table .v-data-table__wrapper table tbody tr:last-child td {
            border-bottom: none !important;
        }

        .list-data-table .v-data-table__wrapper table tbody .v-data-table__empty-wrapper td:last-child {
            border-bottom: none !important;
        }

        .list-data-table .v-data-table__empty-wrapper {
            display: flex;
            justify-content: center;
        }
    }
</style>